const choices = {
    depreciable: 'LMNP option amortissement',
    'censi-bouvard': 'LMNP option Censi-Bouvard',
};

export default choices;
